<template>
  <Intro :labelAndDescColor="customColor"/>
  <WhyChooseUs />
  <!-- <OurHealthPackages /> -->
  <CompareOurHealthPackages />
  <!-- <PathToWebchat v-if=" footerStore.isShowWebchat == true" /> -->

  <div class="sticky bottom-0 right-0 z-50" v-show="footerStore.isShowWebchat">
    <div class="ml-auto cursor-pointer" style="width: 0.8vw; height: 0.8vw; width: 1.5vw; height: 1.5vw; border-radius: 50%; background: white; padding: 0.3vw; display: flex; align-items: center; top: 15px; right: 15px; position: absolute" @click="footerStore.isShowWebchat = false">
      <img src="@/assets/images/shared/eclipse.svg" style="width: inherit; height: inherit" />
    </div>
    <iframe id="myFrame" :src="WEBCHAT_URL" :style="'width:400px;height:604px;border-top-left-radius: 30px;border-top-right-radius: 30px;margin-left:auto'" ref="webchatIframe"></iframe>
  </div>
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/services/subpages/ourcheckuppackages/OurCheckupPackagesIntro.vue";
import WhyChooseUs from "@/components/services/subpages/ourcheckuppackages/WhyChooseUs.vue";
import OurHealthPackages from "@/components/services/subpages/ourcheckuppackages/OurHealthPackages.vue";
import CompareOurHealthPackages from "@/components/services/subpages/ourcheckuppackages/CompareOurHealthPackages.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";
import { useFooterStore } from "@/stores/footer";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const footerStore = useFooterStore();
const WEBCHAT_URL = import.meta.env.WEBCHAT_URL;
const ENV = import.meta.env.MODE;

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});

const customColor = computed(() => {
  return route.meta.color || '#7BA7D8';
});

</script>

